/**
 * Hook to check if the current user has a permission.
 * Use only for UI visibility - backend enforces permissions.
 */
import { useAuth } from '../contexts/AuthContext';

function permissionValueGranted(v: unknown): boolean {
  if (v === true) return true;
  if (v === false || v == null) return false;
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase();
    return s === 'true' || s === '1' || s === 'yes';
  }
  if (typeof v === 'number') return v === 1;
  return false;
}

export function usePermission(key: string): boolean {
  const { user } = useAuth();
  if (!user) return false;
  if (user.role === 'admin') return true;
  const permissions = user.permissions;
  if (permissionValueGranted(permissions?.[key])) return true;
  // Backward compatibility: legacy user-level flags
  if (key === 'add_edit_business' && user.can_edit_businesses === true) return true;
  if (key === 'manage_replacements' && user.can_manage_replacements === true) return true;
  return false;
}
